import { storageLocationIdFormat } from "@redotech/redo-ids-cockroach";
import { StorageLocationTableRowSchema } from "@redotech/redo-model/wms/schema/storage-location";
import * as z from "zod";

export const getStorageLocationById = {
  name: "getStorageLocationById" as const,
  input: z.object({
    storageLocationId: storageLocationIdFormat.schema,
    includeZeroQuantity: z.boolean().optional(),
  }),
  output: z.object({
    storageLocation: StorageLocationTableRowSchema.nullable(),
  }),
};
